import { UserOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Card, Input } from 'antd';
import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import firebase from 'firebase';
import { Link, RouteComponentProps } from 'react-router-dom';

interface IFormComponentProps extends FormComponentProps, RouteComponentProps {
  resetPassword: (email: string) => any;
  loading: boolean;
}

interface IFormState {
  step: number;
  loading: boolean;
  continueButtonDisabled: boolean;
}

class PasswordResetForm extends React.Component<
  IFormComponentProps,
  IFormState
> {
  state = {
    step: 0,
    loading: false,
    continueButtonDisabled: true,
  };

  handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    // @ts-ignore
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { email } = values;
        if (this.state.step === 0) {
          this.setState({
            loading: true,
          });
          try {
            await this.props.resetPassword(email);
          } finally {
            this.setState({
              loading: false,
            });
          }
        }
        this.next();
      }
    });
  };

  // componentDidMount(): void {
  //   if (this.props.location.state.email) {
  //     this.setState({
  //       continueButtonDisabled: false,
  //     });
  //   }
  // }

  next = () => {
    this.setState({
      step: this.state.step + 1,
    });
  };

  goBack = () => {
    const step = this.state.step === 0 ? 0 : this.state.step - 1;

    this.setState(
      {
        step,
      },
      () => {
        if (this.state.step === 0) {
          // @ts-ignore
          this.props.history.replace('/login');
        }
      },
    );
  };

  validateEmail = async (
    rule: any,
    value: any,
    callback: (arg0?: string) => void,
  ) => {
    // @ts-ignore
    const { form } = this.props;

    const valid = /.+@.+\..+/.test(form.getFieldValue('email'));

    if (!valid) {
      callback('Por favor, utiliza un correo electrónico válido');
    } else {
      const signInMethods = await firebase
        .auth()
        .fetchSignInMethodsForEmail(form.getFieldValue('email'));

      const userExists = signInMethods.length > 0;

      if (!userExists) {
        callback('No existe ninguna cuenta con ese correo electrónico');
      } else {
        this.setState({
          continueButtonDisabled: false,
        });
        callback();
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div style={{ background: '#ECECEC', padding: '30px' }}>
        <Card
          title="Restablece tu contraseña"
          bordered={false}
          style={{ width: 350, margin: 'auto' }}
        >
          <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            hideRequiredMark
          >
            <h4>
              {this.state.step === 0
                ? 'Porfavor introduce tu correo electrónico'
                : 'Se enviado un correo electrónico a tu email, sigue las instrucciones mencionadas y una vez restablecida la contraseña, vuelve a iniciar sesión '}
            </h4>
            {this.state.step === 0 ? (
              <Form.Item required>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      required: true,
                      validator: this.validateEmail,
                    },
                  ],
                })(
                  <Input
                    prefix={
                      <UserOutlined
                        style={{ color: 'rgba(0,0,0,.25)' }}
                        translate={undefined}
                      />
                    }
                    type="email"
                    placeholder="Correo electrónico"
                  />,
                )}
              </Form.Item>
            ) : null}

            <Form.Item>
              <Button
                disabled={this.state.continueButtonDisabled}
                type="primary"
                loading={this.state.loading}
                htmlType="submit"
                className="login-form-button"
              >
                {this.state.step === 0 ? (
                  'Continuar'
                ) : (
                  <Link to={'/login'}>Iniciar sesión</Link>
                )}
              </Button>
            </Form.Item>
            <a
              href=""
              style={{ color: 'grey', marginTop: '15px' }}
              onClick={(event) => {
                event.preventDefault();
                this.goBack();
              }}
            >
              Atrás
            </a>
          </Form>
        </Card>
      </div>
    );
  }
}

export const PasswordReset = Form.create<IFormComponentProps>({
  name: 'normal_login',
})(PasswordResetForm);
